import { render } from "./Planets_Atlas.vue?vue&type=template&id=19d7b1f3"
import script from "./Planets_Atlas.vue?vue&type=script&lang=js"
export * from "./Planets_Atlas.vue?vue&type=script&lang=js"

import "./Planets_Atlas.vue?vue&type=style&index=0&id=19d7b1f3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__